import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CmsPostBodyHeaderBreadcrumbsHolder = styled.div`
  flex: 3;
  margin-bottom: 24px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex: 1;
  }
`;

export const CmsPostBodyHeaderCategoriesHolder = styled.div`
  margin-bottom: 24px;

  &[data-hide-below-md] {
    @media all and (max-width: ${cssBreakpoints.mdDown}) {
      display: none;
    }
  }
`;
